// A ListRow-shaped link to somewhere outside the app (a share channel's own URL: WhatsApp, mail,
// SMS). ListRow acts through callbacks; a real `href` lets the browser or the OS handle the
// scheme, and keeps "open in new tab" and the link role.
import "./config";
import { View, styled } from "tamagui";
import { Icon, type IconName } from "./Icon";
import { Fill } from "./layout";
import { Body } from "./text";

const Frame = styled(View, {
  name: "LinkRow",
  render: "a",
  flexDirection: "row",
  alignItems: "center",
  gap: "3",
  paddingVertical: "3",
  paddingHorizontal: "4",
  minHeight: "var(--uiTarget)",
  cursor: "pointer",
  backgroundColor: { default: "surface", press: "surface2" },
  borderBottomWidth: "var(--borderW)",
  borderBottomColor: "line",
  outlineWidth: { default: 0, "focus-visible": 3 },
  outlineStyle: "solid",
  outlineColor: "accent",
  outlineOffset: -3,
});

export interface LinkRowProps {
  icon: IconName;
  label: string;
  href: string;
  testId?: string | undefined;
}

export function LinkRow({ icon, label, href, testId }: LinkRowProps): React.JSX.Element {
  // Tamagui's props do not list the anchor attributes, so they travel as a spread.
  const native = { href, target: "_blank", rel: "noopener noreferrer" };
  return (
    // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
    <Frame {...native} {...(testId === undefined ? {} : { "data-testid": testId })}>
      <Icon name={icon} size={20} />
      <Fill>
        <Body weight="medium" truncate>
          {label}
        </Body>
      </Fill>
    </Frame>
  );
}
